import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { ContextService } from '../core/context.service';

@Injectable({
  providedIn: 'root'
})
export class NoDirectAccessGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private ctx: ContextService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return directAccesGuard(route, this.ctx, this.router);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return directAccesGuard(route, this.ctx, this.router);
  }
}

export const directAccesGuard = (route: ActivatedRouteSnapshot, ctx: ContextService, router: Router) => {
  if (!ctx.isFirstPage$.getValue()) {
    return true;
  }
  const redirect = route.data.redirect as string;
  router.navigate([redirect || '/login']);
  return false;
};
